import {GetterTree} from 'vuex'
import {ActionUsersState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<ActionUsersState, RootState> = {
    actionUsers: state => state.actionUsers ?? [],
    actionUserItem: state => state.actionUserItem ?? [],
    objectTypes: state => state.objectTypes ?? [],
    partnerUsersPages: state => state.partnerUsersPages ?? [],
    partnerUsersPagesItem: state => state.partnerUsersPagesItem ?? [],
};
